<template>
  <div class="bto-sb-event-odds-nav">
    <div class="bto-sb-event-odds-nav-control">
      <div class="bto-sb-event-odds-right">
        <div :class="['bto-sb-event-odds-cell',
         is3WaySport ? 'bto-sb-event-odds-3way' : 'bto-sb-event-odds-2way']">
         {{t(is3WaySport ? 'W.M.3Way' : 'W.M.2Way')}}
        </div>
        <div
          v-if="numberOfMarkets > 1  &&  Object.keys(firstComboSelection).length > 0"
          class="bto-sb-event-odds-cell bto-sb-md-none">
            <div class="bto-sb-form-select" v-if="showCombos">
            <select v-if="showCombos" v-model="firstComboSelection">
              <option v-for="(combi, index) in firstCombo" :key="`${combi.ot}_${index}`" v-bind:value="combi">{{t(combi.n)}}</option>
            </select>
            <div class="bto-sb-form-select-arrow"></div>
            </div>
        </div>
        <div
           v-if="numberOfMarkets > 2 &&  Object.keys(secondComboSelection).length > 0"
           class="bto-sb-event-odds-cell bto-sb-lg-none">
            <div class="bto-sb-form-select" v-if="showCombos">
            <select v-model="secondComboSelection">
              <option v-for="(combi, index) in secondCombo" :key="`${combi.ot}_${index}`" v-bind:value="combi">{{t(combi.n)}}</option>
            </select>
            <div class="bto-sb-form-select-arrow"></div>
            </div>
        </div>
        <div class="bto-sb-event-odds-cell bto-sb-event-morelabel-odds"></div>
        </div>
    </div>
    <div class="bto-sb-event-odds-nav-labels">
        <div class="bto-sb-event-odds-left">
        <div v-if="showEventCode" class="bto-sb-event-odds-cell bto-sb-event-codelabel">{{t('Public.Code')}}</div>
        <div class="bto-sb-event-odds-cell bto-sb-event-timelabel">{{t('Public.Time')}}</div>
        <div class="bto-sb-event-odds-cell bto-sb-event-eventlabel">{{t('Public.Event')}}</div>
        </div>
        <div class="bto-sb-event-odds-right">
        <div class="bto-sb-event-odds-cell">
            <span class="bto-sb-event-marketlabel">{{t('Mobile.outcome1name')}}</span>
            <span v-if="is3WaySport" class="bto-sb-event-marketlabel">{{t('Mobile.outcomexname')}}</span>
            <span class="bto-sb-event-marketlabel">{{t('Mobile.outcome2name')}}</span>
        </div>
        <!-- first combo -->
        <div
           v-if="numberOfMarkets > 1 && (typeof firstComboSelection !== 'undefined' && typeof firstComboSelection.o !== 'undefined')"
           class="bto-sb-event-odds-cell bto-sb-md-none">
          <span v-if="is3WaySport && !hideSBV" class="bto-sb-event-marketlabel">{{t('Public.Goals')}}</span>
          <span v-if="!is3WaySport && !hideSBV" class="bto-sb-event-marketlabel">{{t('Public.Points')}}</span>
          <span class="bto-sb-event-marketlabel"
            v-for="(outcome, index)  in sortedComboSelection(firstComboSelection.o)"
              :key="`${outcome.id}_${index}`">{{t(outcome.n)}}
          </span>

        </div>
        <!-- second combo -->
        <div
          v-if="numberOfMarkets > 2 && (typeof secondComboSelection !== 'undefined' && typeof secondComboSelection.o !== 'undefined')"
           class="bto-sb-event-odds-cell bto-sb-lg-none">
          <span v-if="is3WaySport && !hideSecondColSBV" class="bto-sb-event-marketlabel">{{t('Public.Goals')}}</span>
          <span v-if="!is3WaySport && !hideSecondColSBV" class="bto-sb-event-marketlabel">{{t('Public.Points')}}</span>
          <span class="bto-sb-event-marketlabel"
            v-for="(outcome, index) in sortedComboSelection(secondComboSelection.o)"
              :key="`${outcome.id}_${index}`">{{t(outcome.n)}}
          </span>
        </div>
        <div class="bto-sb-event-odds-cell bto-sb-event-morelabel-odds">{{t('Mobile.more')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../../store/index';

  export default {
    name: 'OddsNavComponent',
    props: {
      is3WaySport: {
        type: Boolean,
        default: true,
      },
      sportId: {
        type: Number,
        default: 0,
      },
      numberOfMarkets: {
        type: Number,
        default: 99,
      },
      showEventCode: {
        type: Boolean,
        default: false,
      },
      showCombos: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        firstComboSelection: {},
        secondComboSelection: {},
        firstCombo: [],
        secondCombo: [],
        emitFirst: false,
        emitSecond: false,
        hideSBV: false,
        hideSecondColSBV: false,
      };
    },

    watch: {
      /**
       *watch if selected sport is changed
      */
      sportId() {
        this.emitFirst = false;
        this.emitSecond = false;
        this.getCombs(this.sportId);
      },
      firstComboSelection() {
        this.hideSBV = !this.firstComboSelection.mb && !this.firstComboSelection.sbv;
        this.$emit('comboOddType', this.firstComboSelection, 1);
        if (this.emitFirst === true) {
          this.$emit('changecombi', this.firstComboSelection, 1);
        }
        this.emitFirst = true;
      },
      secondComboSelection() {
        this.hideSecondColSBV = !this.secondComboSelection.mb && !this.secondComboSelection.sbv;
        this.$emit('comboOddType', this.secondComboSelection, 2);
        if (this.emitSecond === true) {
          this.$emit('changecombi', this.secondComboSelection, 2);
        }
        this.emitSecond = true;
      }
    },
    created() {
      this.getCombs(this.sportId);
    },
    methods: {
      /**
       *Get the available Combos for the selected sport
       */
      getCombs(sportId) {
        const availableCombos = store.state.SportsModule.sportCombos[sportId] || {};
        this.firstCombo = availableCombos.hasOwnProperty(1) ? availableCombos[1] : [];
        if (this.firstCombo.length > 0) {
          this.firstComboSelection = Object.assign({}, this.firstCombo[0]);
        } else {
          this.firstComboSelection = {};
        }
        this.secondCombo = availableCombos.hasOwnProperty(2) ? availableCombos[2] : [];
        if (this.secondCombo.length > 0) {
          this.secondComboSelection = Object.assign({}, this.secondCombo[0]);
        } else {
          this.secondComboSelection = {};
        }
      },
      /**
       * Sort selected combos according to column id
       */
      sortedComboSelection(comboSelection) {
        return [...comboSelection].sort((a, b) => a.cid - b.cid);
      }
    },
  };
</script>
